const mobileSkillRoots = {
  "1": "/managerLearn",
  "2": "/professionalSkill",
  "3": "/marketSkill",
  "4": "/generalSkill",
};

const mobileSkillTypes = {
  managerLearn: "1",
  professionalSkill: "2",
  marketSkill: "3",
  generalSkill: "4",
};

const pcLearningActions = {
  videoCourse: "videoList",
  viewingRecord: "videoRecordList",
  courseware: "courseWare",
  relatedData: "relateData",
};

const mobileLearningActions = {
  videoList: "videoCourse",
  videoRecordList: "viewingRecord",
  courseWare: "courseware",
  relateData: "relatedData",
};

function normalizePath(path) {
  if (!path || path === "/") return path || "/";
  return path.replace(/\/+$/, "");
}

function createTarget(path, query, queryPatch = {}) {
  return {
    path,
    query: {
      ...(query || {}),
      ...queryPatch,
    },
  };
}

export function mapPcPathToMobile(path, query = {}) {
  const normalizedPath = normalizePath(path);
  const learningMatch = normalizedPath.match(/^\/manageriaLearning\/(videoCourse|viewingRecord|courseware|relatedData)\/([1-4])$/);
  if (learningMatch) {
    const action = pcLearningActions[learningMatch[1]];
    const type = learningMatch[2];
    return createTarget(`${mobileSkillRoots[type]}/${action}`, query, { type });
  }

  if (normalizedPath === "/manageriaLearning/play") {
    const type = String(query.type || "1");
    const skillRoot = mobileSkillRoots[type] || mobileSkillRoots["1"];
    return createTarget(`${skillRoot}/videoBox`, query, { type });
  }

  const routeMap = {
    "/": "/login",
    "/login": "/login",
    "/index": "/home",
    "/home": "/home",
    "/institution": "/systemLearn/system",
    "/institution/list": "/systemLearn/system",
    "/institution/type": "/systemLearn/catalog",
    "/manageriaLearning": "/managerLearn/videoList",
    "/teacher": "/teacher/craftsPerson",
    "/teacher/talentList": "/teacher/craftsPerson",
    "/teacher/lecturerList": "/teacher/teacherList",
    "/industryExperts": "/industryExpert/speciaList",
    "/industryExperts/specialist": "/industryExpert/speciaList",
    "/blackLibrary": "/blackLibrary/creditBlacklist",
    "/blackLibrary/personnelData": "/blackLibrary/personalInformation",
    "/blackLibrary/blacklist": "/blackLibrary/creditBlacklist",
    "/HR": "/appointmentLetter/appointmentLetterList",
    "/HR/appointList": "/appointmentLetter/appointmentLetterList",
    "/service": "/serve/officeMap",
    "/service/scattergram": "/serve/officeMap",
    "/service/report": "/serve/industryReport",
    "/service/category": "/serve/officeMap",
    "/service/teamList": "/serve/teamList",
    "/service/courseReview": "/serve/trainShow/courseReview",
    "/service/trainingItem": "/serve/trainShow/trainProject/trainProjectList",
    "/service/noticeRecord": "/serve/trainShow/noticeRecord",
    "/service/talentRecruitment": "/serve/talentRecruitment",
    "/myTable": "/home",
    "/centreList": "/home",
  };

  return createTarget(routeMap[normalizedPath] || normalizedPath, query);
}

export function mapMobilePathToPc(path, query = {}) {
  const normalizedPath = normalizePath(path);
  const learningMatch = normalizedPath.match(/^\/(managerLearn|professionalSkill|marketSkill|generalSkill)\/(videoList|videoRecordList|courseWare|relateData|videoBox)$/);
  if (learningMatch) {
    const type = mobileSkillTypes[learningMatch[1]];
    const action = learningMatch[2];
    if (action === "videoBox") {
      return createTarget("/manageriaLearning/play", query, { type });
    }
    return createTarget(`/manageriaLearning/${mobileLearningActions[action]}/${type}`, query, { type });
  }

  const routeMap = {
    "/": "/login",
    "/login": "/login",
    "/home": "/index",
    "/index": "/index",
    "/systemLearn": "/institution/list",
    "/systemLearn/system": "/institution/list",
    "/systemLearn/readPerson": "/institution/list",
    "/systemLearn/catalog": "/institution/type",
    "/teacher": "/teacher/talentList",
    "/teacher/craftsPerson": "/teacher/talentList",
    "/teacher/personDetail": "/teacher/talentList",
    "/teacher/addPersonData": "/teacher/talentList",
    "/teacher/unrecordPerson": "/teacher/talentList",
    "/teacher/teacherList": "/teacher/lecturerList",
    "/industryExpert": "/industryExperts/specialist",
    "/industryExpert/speciaList": "/industryExperts/specialist",
    "/industryExpert/details": "/industryExperts/specialist",
    "/live": "/index",
    "/live/watchLive": "/index",
    "/live/studyRecord": "/index",
    "/blackLibrary": "/blackLibrary/blacklist",
    "/blackLibrary/creditBlacklist": "/blackLibrary/blacklist",
    "/blackLibrary/personalInformation": "/blackLibrary/personnelData",
    "/serve": "/service/scattergram",
    "/serve/industryReport": "/service/report",
    "/serve/teamList": "/service/teamList",
    "/serve/teamDetail": "/service/teamList",
    "/serve/trainShow": "/service/courseReview",
    "/serve/trainShow/courseReview": "/service/courseReview",
    "/serve/trainShow/reviewDetail": "/service/courseReview",
    "/serve/trainShow/noticeRecord": "/service/noticeRecord",
    "/serve/trainShow/trainProject": "/service/trainingItem",
    "/serve/trainShow/trainProject/trainProjectList": "/service/trainingItem",
    "/serve/trainShow/trainProject/trainProjectDetail": "/service/trainingItem",
    "/serve/trainShow/trainProject/trainStudent": "/service/trainingItem",
    "/serve/officeMap": "/service/scattergram",
    "/serve/talentRecruitment": "/service/talentRecruitment",
    "/appointmentLetter": "/HR/appointList",
    "/appointmentLetter/appointmentLetterList": "/HR/appointList",
    "/appointmentLetter/detail": "/HR/appointList",
    "/vPdf": "/index",
    "/bMap": "/service/scattergram",
  };

  return createTarget(routeMap[normalizedPath] || normalizedPath, query);
}

export function buildExternalRouteUrl(baseUrl, target, extraQuery = {}) {
  const params = new URLSearchParams();
  const query = { ...(target.query || {}), ...extraQuery };
  Object.keys(query).forEach((key) => {
    const value = query[key];
    if (value === undefined || value === null || value === "") return;
    if (Array.isArray(value)) {
      value.forEach((item) => params.append(key, item));
    } else {
      params.append(key, value);
    }
  });
  const queryString = params.toString();
  return `${baseUrl}${target.path}${queryString ? `?${queryString}` : ""}`;
}
